var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 6.41421L0.707107 6.70711C0.316582 7.09763 0.316583 7.7308 0.707107 8.12132L1 8.41421L7 14.4142C7.55228 14.9665 8.44772 14.9665 9 14.4142C9.55228 13.8619 9.55228 12.9665 9 12.4142L4 7.41421L9 2.41421C9.55228 1.86193 9.55228 0.966497 9 0.414213C8.44772 -0.138071 7.55228 -0.138071 7 0.414213L2 5.41421L1 6.41421Z",
    fill: "#FE3E9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftPink);
export default __webpack_public_path__ + "static/media/arrow-left-pink.5e9588442cef18456a2a61178818d4db.svg";
export { ForwardRef as ReactComponent };